
import { TreeNode } from 'primeng/api';
import { Injectable } from '@angular/core';
import { IncludeOrExclude } from '../../../Common/Dialogs/services/data-select-dialog.service.interface';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { JournodexEnumsService } from '../../Core/services/journodex-enums.service';
import { JobRoleModel } from '../../Core/models/job-role.model';
import { AbstractDataSelectDialogService } from '../../../Common/Dialogs/services/abstract-data-select-dialog.service';

export const jobRoleTreeNodeType: string = 'Job Role';
/**
 * This service is the concrete implementation of the abstract class AbstractDataSelectDialogService for job roles.
 *
 * It defines the logic for handling the selection and removal of jobRoles models. It is used in Contact Editor,
 * and Targeting Search.
 */
@Injectable()
export class JobRoleSelectDialogService extends AbstractDataSelectDialogService<JobRoleModel> {
    constructor(
        protected localizationService: LocalizationService,
        protected journodexEnumsService: JournodexEnumsService,
    ) {
        super(
            jobRoleTreeNodeType,
            'Discover.dialogs.browsers.jobrole.header',
            true
        );
        this.journodexEnumsService.getAllJobRoles().subscribe(jobRoles => {
            this.treeNodes = this.convertDataToTreeNodes(jobRoles);
            this.treeNodesProvider.next(this.treeNodes);
        });
    }

    prepareData(state: IncludeOrExclude, jobRoleIds: number[]) {
        this.journodexEnumsService.getJobRolesByIds(jobRoleIds).subscribe(jobRoles => {
            this.selectedItems = jobRoles;
            this.setData(state);
        });
    }

    prepareModelData(state: IncludeOrExclude, jobRoles: JobRoleModel[]) {
        this.selectedItems = jobRoles;
        this.setData(state);
    }

    /**
     * Converts jobRole Model array to TreeNode array and sorts alphabetically
     *
     * @param jobRoles the models to convert
     *
     * @returns TreeNode[]
     */
    protected convertDataToTreeNodes(jobRoles: JobRoleModel[]): TreeNode[] {
        const convertedArray: TreeNode[] = [];
        for (let i = 0; i < jobRoles.length; i++) {
            jobRoles[i].tooltip = this.localizationService.transform('Discover.targeting.definition.jobRoles.' + jobRoles[i].id);
            convertedArray.push({
                label: this.localizationService.transform(jobRoles[i].displayString),
                data: jobRoles[i],
                type: jobRoleTreeNodeType
            });
        }

        return convertedArray.sort(this.sortTreeItemsAlphabetically);
    }

    protected mapSelectedDataToNodes(jobRoles: JobRoleModel[]): TreeNode[] {
        const convertedArray: TreeNode[] = [];
        for (let i = 0; i < jobRoles.length; i++) {
            convertedArray.push(
                this.treeNodes.find((node) => {
                    return (jobRoles[i].id === node.data.id);
                })
            );
        }

        return convertedArray.sort(this.sortTreeItemsAlphabetically);
    }
}
